import React from "react";
import {ColumnsType} from "antd/es/table";
import {FIELD_TYPE, TT_THUOC, TT_VTYT} from "types/enums";
import {ColumnProps} from "types/models";
import {formatDateToString} from "helper/common";
import {DataFormField} from "types/models/input-field-type";
import {ColumnsEdit} from "types/models/column-table-edit";
import {Form, Tooltip, Typography} from "antd";
import dayjs from "dayjs";
import columns from '../../../../../Refractive/InforDetails/DilatePatient/DilatedNetRetinoscopy/FillBtn/config';

const {INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER} = FIELD_TYPE;
const listStatus = [
  {
    value: 0,
    label: "Hợp đồng chưa có hiệu lực",
  },
  {
    value: 1,
    label: "Hợp đồng có hiệu lực",
  },
  {
    value: 2,
    label: "Hợp đồng hết hiệu lực",
  },

];

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    align: "center",
    fixed: "left",
    width: 60,
    isResizable: true,
  },
  {
    title: "Từ ngày",
    key: "ngayBatDau",
    show: true,
    dataIndex: "ngayBatDau",
    width: 150,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Đến ngày",
    key: "ngayHetHD",
    show: true,
    dataIndex: "ngayHetHD",
    width: 150,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Phòng ban",
    key: "phongBan",
    show: true,
    dataIndex: "phongBan",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Chức vụ",
    key: "chucVu",
    show: true,
    dataIndex: "chucVu",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Loại hợp đồng",
    key: "loaiHopDong",
    show: true,
    dataIndex: "loaiHopDong",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Trạng thái hợp đồng",
    key: "trangThai",
    show: true,
    dataIndex: "trangThai",
    width: 150,
    align: "left",
    isResizable: true,
    render: (v, r, i) =>
        listStatus.find(it => it.value === v)?.label || "",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    editable: true,
    width: 140,
    show: true,
    align: "center",
    fixed: "right",
  },
];
const columnsNV: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    align: "center",
    fixed: "left",
    width: 60,
    isResizable: true,
  },
  {
    title: "Nghỉ việc từ ngày",
    key: "ngayNghiViec",
    show: true,
    dataIndex: "ngayNghiViec",
    width: 150,
    align: "center",
    isResizable: true,
  },
  {
    title: "Phòng ban",
    key: "phongBan",
    show: true,
    dataIndex: "phongBan",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Chức vụ",
    key: "chucVu",
    show: true,
    dataIndex: "chucVu",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Loại hợp đồng",
    key: "loaiHopDong",
    show: true,
    dataIndex: "loaiHopDong",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Loại Công Việc",
    key: "loaiCongViec",
    show: true,
    dataIndex: "loaiCongViec",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Số giờ/tuần",
    key: "soGioTuan",
    show: true,
    dataIndex: "soGioTuan",
    width: 150,
    align: "center",
    isResizable: true,
  },
  // {
  //   title: "Thao tác",
  //   dataIndex: "action",
  //   key: "action",
  //   editable: true,
  //   width: 140,
  //   show: true,
  //   align: "center",
  //   fixed: "right",
  // },
];
export {allColumns,columnsNV};
